import {LOADING_START, LOADING_STOP, TEST_START, makeActionCreator} from './actionTypes'

export const loadingStart = makeActionCreator(LOADING_START,'message')
export const loadingStop = makeActionCreator(LOADING_STOP)
export const testStart = makeActionCreator(TEST_START)



// WEBPACK FOOTER //
// ./src/action.js